import {TMergeValues} from './definitions';

export type TDimensions = Readonly<Record<string, number>>;

export const DEFAULT_DIMENSIONS = {
  formWidth: 600,
  controlHeightL: 48,
  controlHeightM: 36,
  controlHeightS: 30,
  controlHeightXS: 24,
  borderWidth: 2,
  radioButtonSize: 20,
} as const satisfies TDimensions;

export const createDimensions = <TCustomDimensions extends TDimensions = TEmptyObject>(
  customDimensions?: TCustomDimensions,
) => {
  return {...DEFAULT_DIMENSIONS, ...customDimensions} as [keyof TCustomDimensions] extends [never]
    ? typeof DEFAULT_DIMENSIONS
    : TMergeValues<typeof DEFAULT_DIMENSIONS, TCustomDimensions>;
};
